import MoreVertIcon from '@mui/icons-material/MoreVert';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Stack, Typography } from '@mui/material';

import Chip from '@mui/material/Chip';

export const headerFn = ({ setModalState }) => [
  // { field: 'id', headerName: 'SL.No', width: 100 },

  {
    field: 'studentName',
    headerName: 'Name',
    width: 300,
    valueGetter: ({ row }) => row?.course_enrollment?.student?.student_name,
    toolTipGetter: ({ row }) => row?.course_enrollment?.student?.student_name,
  },

  {
    field: 'phone',
    headerName: 'Phone Number',
    width: 160,
    valueGetter: ({ row }) => row?.course_enrollment?.student?.student_mob_no,
  },

  {
    field: 'batch',
    headerName: 'Batch',
    width: 180,
    valueGetter: ({ row }) => row?.course_enrollment?.batch_assignment[0]?.course_batch?.course_batch_name,
    toolTipGetter: ({ row }) => row?.course_enrollment?.batch_assignment[0]?.course_batch?.course_batch_name,
  },

  {
    field: 'sessionsCompleted',
    headerName: 'Sessions',
    width: 180,
    type: 'action',
    actionType: 'view',
    actionKey: 'view sessions',
  },

  /* {
    field: 'resumeReceived',
    headerName: 'Resume Received',
    width: 170,
    renderCell: ({ value }) =>
      value ? <CheckCircleOutlineOutlinedIcon color="primary" /> : <RadioButtonUncheckedOutlinedIcon color="primary" />,
  }, */

  /* {
    field: 'interviewDate',
    headerName: 'Interview Scheduled Date',
    width: 220,
  }, */

  /*   {
    field: 'interviewStatus',
    headerName: 'Interview Status',
    width: 160,
    renderCell: ({ value }) => (
      <Chip
        variant="outlined"
        label={Boolean(value) ? (value === 1 ? 'Cleared' : 'Rejected') : 'Pending'}
        color={Boolean(value) ? (value === 1 ? 'success' : 'error') : 'warning'}
      />
    ),
  },
 */
  { field: 'project_name', headerName: 'Qualified Project', width: 200 },
  {
    field: 'firstClassDate',
    headerName: 'Date Of First Class',
    width: 180,
    valueGetter: ({ row }) => row?.firstClassDate ?? 'N/A',
  },

  // { field: 'employer', headerName: 'Employer Name / POC', width: 200 },

  {
    field: 'first_interview_status',
    headerName: 'First Interview Status / Action',
    width: 250,
    renderCell: ({ value, row }) => (
      <Chip
        label={value === '—' ? 'Pending' : value}
        sx={{
          textTransform: 'capitalize',
        }}
        variant="outlined"
        color={value === 'accepted' ? 'success' : value === 'rejected' ? 'error' : 'warning'}
        onClick={() => setModalState({ row, actionKey: 'First InterViewStatus' })}
      />
    ),
  },
  { field: 'first_interview_comments', headerName: 'First Interview Comment', width: 250, toolTipGetter: true },
  {
    field: 'final_interview_status',
    headerName: 'Final Interview Status / Action',
    width: 250,
    renderCell: ({ value, row }) => (
      <Chip
        label={value === '—' ? 'Pending' : value}
        variant="outlined"
        color={value === 'accepted' ? 'success' : value === 'rejected' ? 'error' : 'warning'}
        sx={{
          cursor: row?.first_interview_status === 'accepted' ? 'pointer' : 'not-allowed',
          textTransform: 'capitalize',
        }}
        onClick={() =>
          row?.first_interview_status === 'accepted' ? setModalState({ row, actionKey: 'Final InterViewStatus' }) : null
        }
      />
    ),
  },
  { field: 'final_interview_comments', headerName: 'Final Interview Comment', width: 250, toolTipGetter: true },
  {
    field: 'completion',
    headerName: 'Profile Completion',
    align: 'left',
    width: 250,
    renderCell: ({ row }) => (
      <Stack gap={1} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        {row?.trainer?.completion ? (
          <Typography color={'#5fb943ff'}>Completed</Typography>
        ) : (
          <Typography color={'#fe4841'}>Incompleted</Typography>
        )}
        <Stack direction={'row'}>
          <IconButton
            onClick={() => {
              const phone = row?.trainer?.mob_no;
              const message = `email : ${row?.trainer?.email_id}\npassword : ${row?.trainer?.paswd}\nportal:https://workspace.teaminterval.net/`;
              const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

              window.open(url, '_blank');
            }}
          >
            <WhatsAppIcon
              color="inherti"
              sx={{
                width: 20,
                height: 20,
              }}
            />
          </IconButton>
          <IconButton
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(
                  `email : ${row?.trainer?.email_id}\npassword : ${row?.trainer?.paswd}\nportal:https://workspace.teaminterval.net/`,
                );
              } catch (err) {
                console.error('Failed to copy: ', err);
              }
            }}
          >
            <ContentCopyIcon
              sx={{
                width: 20,
                height: 20,
              }}
            />
          </IconButton>
        </Stack>
      </Stack>
    ),
  },

  // { field: 'doj', headerName: 'DOJ', width: 140 },

  {
    field: 'placement_type',
    headerName: 'Placement Type',
    width: 200,
    renderCell: ({ value, row }) => {
      let obj = {
        color: '',
      };

      switch (value) {
        case 'intern':
          obj.color = 'primary';
          break;
        case 'tutor':
          obj.color = 'success';
          break;
        case 'rejected':
          obj.color = 'error';
          break;

        default:
          obj.color = 'warning';
      }

      return (
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Chip variant="filled" label={row?.placement_type ?? 'Pending'} color={obj.color} />
          <IconButton
            aria-label="more"
            id="long-button"
            aria-haspopup="true"
            onClick={() => setModalState({ actionKey: 'Change Status', row })}
          >
            <MoreVertIcon />
          </IconButton>
        </Stack>
      );
    },
  },
];
